export default "__VITE_ASSET__DYAmntYB__"